import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";

export const getAllNewsletter = createAsyncThunk(
  "Website/FindAllNewsLetter",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Website/FindAllNewsLetter`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Newsletters:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
